module.exports = __webpack_public_path__ + "img/logo1.ab36b34e.png";